import { render, staticRenderFns } from "./planlist.vue?vue&type=template&id=a48238d6&scoped=true&"
import script from "./planlist.vue?vue&type=script&lang=js&"
export * from "./planlist.vue?vue&type=script&lang=js&"
import style0 from "./planlist.vue?vue&type=style&index=0&id=a48238d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48238d6",
  null
  
)

export default component.exports